import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type DeleteKudoRouteParameters = {
  id: string;
};

export const deleteKudo = async ({ routeParams: { id } }: RouteParamsRequest<DeleteKudoRouteParameters>) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.kudos.delete(id));
